import store from '~/store';
import { getCurrent } from '~/api/user';

function sanitizeUser(user) {
  const {
    Id,
    ClientId,
    UserName,
    ClientName,
    Avatar,
    MasterClientId,
  } = user;
  return {
    Id,
    ClientId,
    UserName,
    ClientName,
    Avatar,
    MasterClientId,
  };
}

export async function loadUser() {
  const data = await getCurrent();
  if (data) {
    await store.dispatch('user/signIn', sanitizeUser(data));
  }
}

